import * as _ from "lodash";
import RouteUpdateActions from "./RouteUpdateActions.js";
let detectTooManyDispatches = {};
const limitCountOfCalls = 30;
function dispatchRouteUpdateOnHistoryLocation(store, history) {
  const unlisten = history.listen((location, action) => {
    const currentPeriod = Math.round(performance.now() / 1e3);
    let currentPeriodCount = detectTooManyDispatches[currentPeriod] | 0;
    currentPeriodCount++;
    if (currentPeriodCount > limitCountOfCalls) {
      throw `history dispatch called to many times.  Exceeded the limit of ${limitCountOfCalls} in the last second`;
    }
    detectTooManyDispatches = {};
    detectTooManyDispatches[currentPeriod] = currentPeriodCount;
    const state = store.getState();
    const { routeState } = state || {};
    const { routeLocation } = routeState || {};
    if (!!routeLocation) {
      if (_.some(["search", "pathname", "hash"], (p) => location[p] !== routeLocation[p])) {
        store.dispatch(RouteUpdateActions.routeUpdate(location));
      }
    } else {
      console.error("RouteLocation not initialized properly");
    }
  });
  store.dispatch(RouteUpdateActions.routeUpdate(history.location));
  return unlisten;
}
export {
  dispatchRouteUpdateOnHistoryLocation as default
};
//# sourceMappingURL=DispatchRouteUpdateOnHistoryLocation.js.map
